import { Component, Inject, ViewChildren, QueryList, ViewChild, AfterViewInit, OnInit } from '@angular/core';
import { HttpService, UtilService } from '@app/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FocusNextDirective } from '@app/shared/focus-next.directive';
import { environment } from '@env';
import { FormGroup, FormControl, FormBuilder, NgForm } from '@angular/forms';
import {MatProgressBarModule} from '@angular/material/progress-bar';

@Component({
	selector: 'app-informe-upload',
	templateUrl: 'informeUploader.html',
	styleUrls: ['informeUploader.css'],
})
export class InformeUploader implements OnInit, AfterViewInit  {

	constructor(
	    public dialogRef: MatDialogRef<InformeUploader>,
	    private httpService: HttpService,
		private utilService: UtilService,
		private fb: FormBuilder,
	    @Inject(MAT_DIALOG_DATA) public data: any
    ) { }

    cargandoHistory = false;
	anteriores: any =  null;
	historyList = false;
	ocupado = false;

    ngOnInit() {

    }

	ngAfterViewInit() {
		const dataCons = {
			columna: 'StudyDate',
			cuantos: 10,
			datosEst: '',
			direccion: 'desc',
			fecha: null,
			paciente: this.data.study.PatientID,
			pag: 0,
			servidor: this.data.server,
			tipoEst: []
		};
/*
// No se trae el historial
		this.httpService.post('img/study', dataCons).then( anteriores => {
			this.anteriores = anteriores.data;
			this.cargandoHistory = false;
		});
*/
    }

	canceLar() {
		this.dialogRef.close();
	}

	onSubmit(como) { // Despreciada.. Despreciada?
		this.dialogRef.close(); // grabar o no grabar..
		// console.log('tengo onSubmit',this.informeForm.getRawValue());
	}

	toggleViewPort() {
		return this.historyList = !this.historyList;
	}

	fileChange(event) {
		let fileList: FileList = event.target.files;
		if(fileList.length > 0) {
			let file: File = fileList[0];
			let formData:FormData = new FormData();
			formData.append('uploadFile', file, file.name);
			formData.append('StudyInstanceUID', this.data.study.StudyInstanceUID);
			formData.append('AccessionNumber',this.data.study.AccessionNumber);
			formData.append('PatientID',this.data.study.PatientID);
			formData.append('servidor',this.data.server);
			let headers = new Headers();
			headers.append('Content-Type', 'multipart/form-data');
			headers.append('Accept', 'application/json');
			const optOptions = {
				withCredentials: true,
				headers: headers
			};
			this.ocupado = true;
			this.httpService.file('informes',formData,optOptions).then( (data)=> {
				this.ocupado = false;
				console.log('jeje',data);
				this.canceLar();
			}).catch ( (eso) => {
				this.ocupado = false;
			});
		}
	}

}